import { createReducer, on } from '@ngrx/store';
import * as PickingsActions from '../actions/pickings.actions';

export const pickingsFeatureKey = 'pickings';

export interface State {
  currentPage: number,
  pickings: any,
  pickingsPath: any,
  filterType: string,
  filterID: number
  total: number,
  query: string,
  isLoading: boolean,
  sortType: string,
  direction: string,
  picking: any,
  selected: any,
  isMasterChecked: boolean,
  barcodes: any[]

  /**
   * Errors
   */
  duplicateBarcode: boolean
}

export const initialState: State = {
  currentPage: 0,
  pickings: null,
  pickingsPath: null,
  picking: null,
  filterType: null,
  total: 0,
  filterID: 0,
  query: "",
  isLoading: true,
  sortType: null,
  direction: null,
  selected: [],
  isMasterChecked: false,
  barcodes: null,
  duplicateBarcode: false
};

export const reducer = createReducer(
  initialState,

  on(PickingsActions.loadPickings, state => state),
  on(PickingsActions.loadPickingsSuccess, (state, action) => ({
    ...state,
    pickings: [...action.pickings],
    total: action.total,
    isLoading: false
  })),
  on(PickingsActions.loadPickingsFailure, (state, action) => state),
  on(PickingsActions.updatePicking, state => state),
  on(PickingsActions.updatePickingSuccess, (state, { picking }) => ({
    ...state,
    pickings: state.pickings.map(item => {
      if(picking!=null && picking.productMovementHistoryID!=null && item.productMovementHistoryID == picking.productMovementHistoryID){
        return picking;
      }else{
        return item
      }
    }),
    picking: picking,
    isLoading: false
  })),
  on(PickingsActions.loadPicking, state => state),
  on(PickingsActions.loadPickingSuccess, (state, action) => ({
    ...state,
    picking: action.picking,
    isLoading: false
  })),
  on(PickingsActions.loadPickingFailure, (state, action) => state),
  on(PickingsActions.filterByCategory, (state, action )=> ({
    ...state,
    sortType: action.active,
    direction: action.direction,
    isLoading: true
  })),
  on(PickingsActions.filterByCategorySuccess, (state, action) => ({
    ...state,
    pickings: action.pickings,
    total: action.total,
    isLoading: false
  })),
  on(PickingsActions.filterByCategoryFailure, (state, action) => ({
    ...state,
    error: action.error,
  })),
  on(PickingsActions.filterByArea, (state, action )=> ({
    ...state,
    sortType: action.active,
    direction: action.direction,
    isLoading: true
  })),
  on(PickingsActions.filterByAreaSuccess, (state, action) => ({
    ...state,
    pickings: action.pickings,
    total: action.total,
    isLoading: false
  })),
  on(PickingsActions.filterByAreaFailure, (state, action) => ({
    ...state,
    error: action.error,
  })),
  on(PickingsActions.deletePicking, (state, action) => ({
    ...state,
  })),
  on(PickingsActions.deletePickingSuccess, (state, action) => ({
    ...state,
    pickings: state.pickings.filter(picking => picking.productMovementHistoryID != action.productMovementHistoryID),
  })),
  on(PickingsActions.deletePickingsSuccess, (state, action) => ({
    ...state,
    isMasterChecked: false
  })),
  on(PickingsActions.savePicking, state => state),
  // Initial state has pickings = null; a save dispatched before the pickings
  // page was ever visited would crash the store on spread.
  on(PickingsActions.savePickingSuccess, (state, action) => ({
    ...state,
    pickings: [action.picking, ...(state.pickings || [])],
    total: state.total +  1
  })),
  on(PickingsActions.savePickingFailure, (state, action) => state),

  on(PickingsActions.search, (state, action) => ({
    ...state,
    query: action.query,
    isLoading: true
  })),
  on(PickingsActions.searchSuccess, (state, action) => ({
    ...state,
    pickings: action.pickings,
    total: action.total,
    isLoading: false
  })),
  on(PickingsActions.searchFailure, (state, action) => ({
    ...state,
    error: action.error,
  })),
  on(PickingsActions.incrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage + 1
  })),
  on(PickingsActions.decrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage - 1
  })),
  on(PickingsActions.resetPage, (state, action) => ({ 
    ...state,
    currentPage: 0
  })),
  on(PickingsActions.incrementPage, (state, action) => ({ 
    ...state,
  })),
  on(PickingsActions.incrementPageSuccess, (state, action) => ({ 
    ...state,
    currentPage: action.currentPage
  })),
  on(PickingsActions.setFilterType, (state, action) => ({
    ...state,
    filterType: action.filterType,
    filterID: action.filterID
  })),
  on(PickingsActions.setSelected, (state, action) => ({
    ...state,
    selected: action.selected,
    isMasterChecked: true
  })),
  on(PickingsActions.setDeselected, (state) => ({
    ...state,
    selected: [],
    isMasterChecked: false
  })),
  on(PickingsActions.setSort, (state, action) => ({
    ...state,
    sortType: action.sort,
    direction: action.direction
  })),
  on(PickingsActions.resetPicking, (state, action) => ({
    ...state,
    picking: null
  })),
  on(PickingsActions.resetPickings, (state, action) => ({
    ...state,
    pickings: [],
    isLoading: true
  })),
  on(PickingsActions.resetFilter, (state, action) => ({
    ...state,
    filterType: null,
    filterID: null
  })),
  on(PickingsActions.createBarcode, (state, action) => ({
    ...state,
    barcodes: [...state.barcodes, {
      barcodeData: action.barcodeData
    }],
    duplicateBarcode: false
  })),
  on(PickingsActions.setBarcodes, (state, action) => ({
    ...state,
    barcodes: action.barcodes
  })),
  on(PickingsActions.createBarcodeFailure, (state, action) => ({
    ...state,
    duplicateBarcode: true
  })),
  on(PickingsActions.createBarcodeFailure, (state, action) => ({
    ...state,
    duplicateBarcode: true
  })),
  on(PickingsActions.setSelectedBarcode, (state, action) => ({
    ...state,
    barcodes: state.barcodes?.map((item, index) => {
      if(index != action.index){
        item.selected = false;
      }else{
        item.selected = true;
      }
      return item;
    })
  })),
  on(PickingsActions.deleteBarcode, (state, action) => ({
    ...state,
    barcodes: state.barcodes.filter(item => item.barcodeID != action.barcodeID)
  })),
  on(PickingsActions.setIsLoading, (state, action) => ({
    ...state,
    isLoading: action.isLoading
  })),
  on(PickingsActions.saveOverrideSuccess, (state, action) => ({
    ...state,
  })),

);
